import './addLead.css';
import CloseIcon from '../../../assets/icons/trvto_close.svg';
import { useState } from 'react';
import { supAddChatbotUser } from '../../../api/supportAdmin';
import { toast } from 'react-toastify';

const initialState = {
    name: '',
    phoneNumber: '',
    igUserId: '',
    platform: '',
    leadStatus: '',
    selectedCity: '',
    selectedPlace: '',
    travellerCount: ''
};

const statuses = [
    {
        value: 'New',
        label: 'New'
    },
    {
        value: 'Contacted',
        label: 'Contacted'
    },
    {
        value: 'Interested',
        label: 'Interested'
    },
    {
        value: 'Follow Up',
        label: 'Follow Up'
    },
    {
        value: 'Booked',
        label: 'Booked'
    },
    {
        value: 'Closed',
        label: 'Closed'
    }
];

const AddLead = ({ open, onClose }) => {
    const [formData, setFormData] = useState(initialState);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await supAddChatbotUser(formData);

            toast.success(response?.data?.message || 'Chatbot User added successfully.');

            onClose();
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong.');
        }
    };
    if (!open) return null;
    return (
        <div className='lead-overlay'>
            <div className='lead-modal'>
                <div className='leadHeader'>
                    <h2>Add Lead</h2>
                    <img
                        src={CloseIcon}
                        width={30}
                        height={30}
                        onClick={() => {
                            onClose();
                            setFormData(initialState);
                        }}
                    />
                </div>
                <form className='lead-form' onSubmit={handleSubmit}>
                    <div className='lead-field'>
                        <label>Platform</label>

                        <select name='platform' value={formData.platform} onChange={handleChange} required>
                            <option value=''>Select Platform</option>
                            <option value='whatsapp'>Whatsapp</option>
                            <option value='instagram'>Instagram</option>
                        </select>
                    </div>

                    <div className='lead-field'>
                        <label>Name</label>

                        <input
                            type='text'
                            name='name'
                            placeholder='Enter name'
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className='lead-field'>
                        <label>Phone Number</label>
                        <input
                            type='text'
                            name='phoneNumber'
                            placeholder='Enter Number'
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className='lead-field'>
                        <label>Start City</label>
                        <input
                            type='text'
                            name='selectedCity'
                            placeholder='Enter start city'
                            value={formData?.selectedCity || ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className='lead-field'>
                        <label>Destination Place</label>
                        <input
                            type='text'
                            name='selectedPlace'
                            placeholder='Enter destination place'
                            value={formData?.selectedPlace || ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className='lead-field'>
                        <label>No of Travellers</label>
                        <input
                            type='text'
                            name='travellerCount'
                            placeholder='Enter no of travellers'
                            value={formData?.travellerCount || ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className='lead-field'>
                        <label>Lead Status</label>

                        <select name='leadStatus' value={formData.leadStatus} onChange={handleChange} required>
                            <option value=''>Select Status</option>
                            {statuses.map((status) => {
                                return <option value={status.value}>{status.label}</option>;
                            })}
                        </select>
                    </div>

                    <div className='lead-footer'>
                        <button
                            type='button'
                            className='lead-cancel'
                            onClick={() => {
                                onClose();
                                setFormData(initialState);
                            }}
                        >
                            Cancel
                        </button>

                        <button type='submit' className='lead-save'>
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddLead;
